import React from "react";
import { Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Achievement as AchievementType } from "../../firebase/achievements";
import { colors } from "../../theme";

interface Props {
  title: string;
  description: string;
  achievement: AchievementType;
  icon: string;
}

const useStyles = makeStyles({
  card: {
    minWidth: 200,
    borderRadius: 0,
    boxShadow: "none",
    backgroundColor: "transparent",
  },
  title: {
    height: "30px",
    fontSize: "20px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.05px",
    color: colors.TEXT_PRIMARY,
  },
  description: {
    height: "60px",
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "2",
    letterSpacing: "-0.04px",
    color: colors.TEXT_SECONDARY,
  },
});

export default function Achievement({
  title,
  description,
  achievement,
  icon,
}: Props) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <div style={{ textAlign: "center" }}>
          <img src={icon} alt={title} />

          <div className={classes.title}>
            <b>{title}</b>
          </div>

          <div className={classes.description}>{description}</div>
        </div>
      </CardContent>
    </Card>
  );
}
